// @ts-nocheck
import Zone from "@insite/client-framework/Components/Zone";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Tab, { TabPresentationProps } from "@insite/mobius/Tab";
import TabGroup, { TabGroupPresentationProps } from "@insite/mobius/TabGroup";
import React from "react";

type Props = WidgetProps;

export interface CheckoutReviewAndSubmitSplitOrdersTabsContainerStyles {
    tabGroup?: TabGroupPresentationProps;
    tabContainer?: TabPresentationProps;
}

export const splitOrdersTabsContainerStyles: CheckoutReviewAndSubmitSplitOrdersTabsContainerStyles = {};

const styles = splitOrdersTabsContainerStyles;

const CheckoutReviewAndSubmitSplitOrdersTabsContainer: React.FC<Props> = ({ id }) => {
    return (
        <TabGroup {...styles.tabGroup}>
            <Tab {...styles.tabContainer} headline={translate("Order")} key="Order" tabKey="Order_0">
                <Zone contentId={id} zoneName="SplitOrders_Order" />
            </Tab>
            <Tab {...styles.tabContainer} headline={translate("Date")} key="Date" tabKey="Date_1">
                <Zone contentId={id} zoneName="SplitOrders_Date" />
            </Tab>
        </TabGroup>
    );
};

const widgetModule: WidgetModule = {
    component: CheckoutReviewAndSubmitSplitOrdersTabsContainer,
    definition: {
        displayName: "Split Orders Tabs Container",
        allowedContexts: ["CheckoutReviewAndSubmitPage"],
        group: "Checkout - Review & Submit",
    },
};

export default widgetModule;
